import React from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'react-bootstrap/Accordion';


// selectors

import { selectIsDashboardModelsIsLoading, selectSortedDashboardModels } from '../../../../selectors/dashboardLiteSelectors';

// components

import CoverageAccordionItem from './CoverageAccordionItem';

const CoverageAccordion = () => {
    const isLoading = useSelector(selectIsDashboardModelsIsLoading);
    const dashboardModels = useSelector(selectSortedDashboardModels);

    if (isLoading) return null;

    const coverageData = dashboardModels.map(({ applicationYear, enrollments }) => (
        <CoverageAccordionItem key={applicationYear} {...{ applicationYear, enrollments }}/>
    ));

    const defaultYear = dashboardModels && dashboardModels.length > 0 ? dashboardModels[0].applicationYear : null;
    return (
        <Accordion className={'gi-accordion'} defaultActiveKey={defaultYear}>
            { coverageData }
        </Accordion>
    );
};

export default CoverageAccordion;